module.exports = __webpack_public_path__ + "img/media (5).fe4cdd3b.png";